/**
 * Pricing Manager — schema del Deal Context (port verbatim de
 * shared/schema.ts de Replit). El backend valida con una copia idéntica
 * en routers/pricing.ts; si cambia una, cambiar la otra.
 */
import { z } from "zod";

export const dealContextSchema = z.object({
  client: z.string().min(1, "Client is required"),
  segment: z.string().optional(),
  currency: z.string().min(1, "Currency is required"),
  society: z.string().min(1, "Society is required"),
  revenueType: z.string().min(1, "Revenue Type is required"),
  dealType: z.string().min(1, "Deal Type is required"),
  solutions: z.array(z.string()).min(1, "At least one solution is required"),
  durationMonths: z.number().min(1, "Duration is required").max(60, "Duration must be between 1 and 60 months"),
  paymentTerms: z.string().min(1, "Payment Terms is required"),
  versionName: z.string().min(1, "Version name is required").max(100, "Version name is too long").refine(
    (val) => val.trim().split(/\s+/).length <= 5,
    "Version name must be 5 words or less"
  ),
  comments: z.string().optional(),
});

export type DealContextForm = z.infer<typeof dealContextSchema>;
